import React from 'react';

const IconInternal = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-internal">
    <title>Learn More</title>
    <path d="M9 19h6" />
    <path d="M12 2a6 6 0 0 0-6 6c0 1 .2 2 .6 2.8l1.4 2.7c.3.6 1 1.5 1 1.5h6s.7-.9 1-1.5l1.4-2.7c.4-.8.6-1.8.6-2.8a6 6 0 0 0-6-6Z" />
    <path d="M10 17h4" />
  </svg>
);

export default IconInternal;
